import React from 'react';
import { Route as ReactRoute, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs/memo';
import { patchPath } from 'utils/patch-path';
import { Route, routes } from './routes';

export const Routes = memo(() => <NestedRoutes routesTree={routes} />);

export const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree }) => (
  <Switch>
    {routesTree?.map(({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
      <ReactRoute path={patchPath(path)} key={key} strict={strict} exact={exact}>
        {Component ? (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <Component>
            <NestedRoutes routesTree={nestedRoutes} />
          </Component>
        ) : (
          <NestedRoutes routesTree={nestedRoutes} />
        )}
      </ReactRoute>
    ))}
  </Switch>
);
